import { Col, Container, Row } from 'react-bootstrap'
import { useEffect, useState } from 'react'
import { observer } from 'mobx-react-lite'
import { Pagination } from '@mui/material'
import { AnimatePresence, motion } from 'framer-motion'
import { useTranslation } from 'react-i18next'
import { cloneDeep } from 'lodash'
import AuctionCard from './components/auction/AuctionCard'
import FooterNew from './components/Footer'
import { useStore } from '../app/stores/store'
import PostCard from './components/post/PostCard'
import { history } from '..'
import HomeFilter from './components/HomeFilter'
import { FilterModes } from '../app/models/modes'
import ComponentLoader from './components/loaders/ComponentLoader'

function Home() {
  const { auctionListStore, postListStore, navigationStore, homeFilterStore } = useStore()
  const { auctions } = auctionListStore
  const { posts } = postListStore
  const { show, setShow, filterResult, loading, setSearch, search, listHomeFilter } =
    homeFilterStore
  const [page, setPage] = useState(1)
  const paginateAuctions = 3
  const { t } = useTranslation()

  useEffect(() => {
    auctionListStore.loadAuctions()
    postListStore.loadPosts()
  }, [auctionListStore, postListStore])

  function handlePostRedirect() {
    history.push('/posts')
  }

  function handleAuctionRedirect() {
    history.push('/auctions')
  }

  function paginate(array: any) {
    return array.slice((page - 1) * paginateAuctions, page * paginateAuctions)
  }

  const handleTagsClick = async (city: string) => {
    window.scrollTo({
      top: 300,
      behavior: 'smooth',
    })
    const filter = cloneDeep(search)
    filter.city = city
    setSearch(filter)

    await new Promise((resolve) => setTimeout(resolve, 1000))

    listHomeFilter(filter)
    setShow(true)
  }

  return (
    <div className='d-flex justify-content-center'>
      <div className='home-background-image'>
        <HomeFilter />
        <AnimatePresence>
          {loading && <ComponentLoader />}
          {show && !loading && (
            <motion.div
              initial={{ opacity: 0, height: 0 }}
              animate={{ opacity: 1, height: 'auto' }}
              exit={{ opacity: 0, height: 0 }}
              transition={{ duration: 0.2 }}
            >
              <Container fluid className='newFont home-container'>
                <div className='latest-auctions'>
                  <div className='latest-auction-header'>
                    <h1>
                      {t('search_result')}: {filterResult?.length}
                    </h1>
                    <button className='auction-card-body-button' onClick={() => setShow(false)}>
                      {t('close')}
                    </button>
                  </div>

                  <div className='latest-auction-body'>
                    {paginate(
                      filterResult?.map((res: any, index) =>
                        res.resultType == FilterModes.post ? (
                          <PostCard key={index} post={res.resultDto} />
                        ) : (
                          <AuctionCard key={index} auction={res.resultDto} />
                        ),
                      ),
                    )}
                    {filterResult?.length === 0 && (
                      <h1 className='mt-5 text-center mb-5'>{t('no_auctions')}</h1>
                    )}
                  </div>
                  {filterResult.length > 0 && (
                    <Pagination
                      color='primary'
                      className='auctions-pagination mt-5'
                      sx={{
                        width: '100%',
                        '& .MuiPaginationItem-root.Mui-selected, .MuiPaginationItem-root.Mui-selected:hover':
                          {
                            backgroundColor: '#4f7f71',
                          },
                      }}
                      page={page}
                      size='large'
                      onChange={(e, value) => setPage(value)}
                      count={Math.ceil(filterResult.length / paginateAuctions)}
                    />
                  )}
                </div>
              </Container>
            </motion.div>
          )}
        </AnimatePresence>
        <Container fluid className='newFont home-container mt-3 pt-3'>
          <div className='latest-auctions'>
            <div className='latest-auction-header'>
              <h1>{t('latest_auctions')}</h1>
              <p className='hover-redirect-p' onClick={handleAuctionRedirect}>
                {t('all_auctions')} →
              </p>
            </div>
            <div className='latest-auction-body'>
              {navigationStore
                .latestSortFilter(auctions)
                .slice(0, 3)
                .map((auction) => (
                  <AuctionCard key={auction.id} auction={auction} />
                ))}
              {auctions.length === 0 && <h1 className='mt-5 text-center'>{t('no_auctions')}</h1>}
            </div>
          </div>
        </Container>
        <Container fluid className='newFont home-container mt-5 pt-3'>
          <div className='latest-auctions'>
            <div className='latest-auction-header'>
              <h1>{t('latest_posts')}</h1>
              <p className='hover-redirect-p' onClick={handlePostRedirect}>
                {t('all_posts')} →
              </p>
            </div>
            <div className='latest-auction-body'>
              {navigationStore
                .latestSortFilter(posts)
                .slice(0, 3)
                .map((post) => (
                  <PostCard key={post.id} post={post} />
                ))}
              {posts.length === 0 && <h1 className='mt-5 text-center'>{t('no_posts')}</h1>}
            </div>
          </div>
        </Container>
        <Container fluid className='newFont tags-container latest-auctions'>
          <h1>
            {t('popular_locations')}: {t('properties_for_rent')}
          </h1>
          <div className='tag-container-list'>
            {navigationStore.popularCitiesFilter(posts).map((city, index) => (
              <button onClick={() => handleTagsClick(city)} key={index}>
                {city}
              </button>
            ))}
          </div>
        </Container>
        <Container className='home-footer-banner'>
          <div className='home-footer-content'>
            <Row>
              <Col xl={7}>
                <div className='home-footer-content-header'>
                  <h1>
                    <strong>{t('home_img_footer_h1')}</strong>
                  </h1>
                  <p>{t('home_img_footer_h2')}</p>
                </div>
                <div className='home-footer-content-body'>
                  <p>{t('home_img_footer_desc')}</p>
                </div>
              </Col>
              <Col />
            </Row>
          </div>
        </Container>
        <FooterNew />
      </div>
    </div>
  )
}
export default observer(Home)
